export const getTextBlock = (componentData) => {
    const item = componentData?.fields?.elements[0]?.fields;

    return {
        title: item?.title,
        subtitle: item?.subtitle,
        text: item?.description
    };
};